import { Table, TableBody, TableCell, TableHead, TableRow } from '@material-ui/core'
import React from 'react'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import TaxDisplayNameItem from './TaxDisplayNameItem'

const TaxDisplayNameItemEditable = EditableHOCWrapper(TaxDisplayNameItem)

class TaxDisplayNames extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editingIndex: null,
    }
  }

  setEditingIndex = (index) => {
    this.setState({ editingIndex: index })
  }

  clearEditingIndex = () => {
    this.setState({ editingIndex: null })
  }

  onSave = (index) => (data, afterSave) => {
    this.props.onSave(index, data, afterSave)
  }

  render() {
    const {
      taxDisplayNames = [],
      lastModifiedDisplayNames,
      companyFeatures = {},
      taxTypeMapping = false,
      taxTypeOptions = [],
      isAnyEditing = false,
      handleAnyEdit,
    } = this.props
    const { editingIndex } = this.state

    return (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Tax Name </TableCell>
            <TableCell>Display Name</TableCell>
            {companyFeatures.enableAppendTax ? (
              <TableCell>Append "Tax" to all tax names</TableCell>
            ) : null}
            {taxTypeMapping ? <TableCell>Tax Type</TableCell> : null}
            <TableCell></TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {taxDisplayNames && taxDisplayNames.length
            ? taxDisplayNames.map((item, i) => {
                return (
                  <TaxDisplayNameItemEditable
                    key={i}
                    dataToEdit={item}
                    onSave={this.onSave(i)}
                    lastModified={lastModifiedDisplayNames}
                    companyFeatures={companyFeatures}
                    taxTypeMapping={taxTypeMapping}
                    taxTypeOptions={taxTypeOptions}
                    isAnyEditing={isAnyEditing}
                    handleAnyEdit={handleAnyEdit}
                    isEditing={editingIndex === i}
                    setEditingIndex={() => this.setEditingIndex(i)}
                    clearEditingIndex={this.clearEditingIndex}
                  />
                )
              })
            : null}
        </TableBody>
      </Table>
    )
  }
}

export default TaxDisplayNames



// WEBPACK FOOTER //
// ./src/components/TaxOption/TaxDisplayNames.js